const pLineKey = (state) => {
    return !state.data ? '' : `${state.data.name.replace(/ /gi, '-')}-${state.data.sku || ''}`
}

export default {
    pLineKey,
}
